import { render } from "./BlogAdminPageNoAuth.vue?vue&type=template&id=c8964106"
import script from "./BlogAdminPageNoAuth.vue?vue&type=script&lang=js"
export * from "./BlogAdminPageNoAuth.vue?vue&type=script&lang=js"

import "./BlogAdminPageNoAuth.vue?vue&type=style&index=0&id=c8964106&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__